export const collectionService = {
    getCollections,
    postUploadCollections,
    postAuth
}

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
const REACT_APP_AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL;
const REACT_APP_APP_ID = process.env.REACT_APP_APP_ID;

function getCollections(TOKEN) {
    const requestOptions = {
        method: 'GET',
        headers:
        {
            'Content-Type': 'application/json',
            "token": TOKEN
        },
    };

    return fetch(`${REACT_APP_API_URL}/api/v1/collection_documents/file_parameters`, requestOptions).then(handleResponse);
}

function postUploadCollections(params = {}, TOKEN) {
    const formData = new FormData();

    formData.append('collection_document[file_type]', params.file_type);
    formData.append('collection_document[file]', params.file);

    const requestOptions = {
        method: 'POST',
        headers: { "token": TOKEN },
        body: formData
    };
    return fetch(`${REACT_APP_API_URL}/api/v1/collection_documents`, requestOptions).then(handleResponse);
}

function postAuth(auth) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', "APP-id": REACT_APP_APP_ID },
        body: JSON.stringify(auth)
    };
    return fetch(`${REACT_APP_AUTH_API_URL}/api/v1/auth`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.errors) || response.statusText;
            return Promise.reject(error || 'Internal Server Error');
        }
        return data;
    });
}